"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var material_1 = require("@mui/material");
var styles_1 = require("@mui/material/styles");
var DefaultPropsHoC_1 = __importDefault(require("components/Generic/DefaultPropsHoC"));
var general_1 = require("utils/general");
var constants_1 = require("../Logo/constants");
var AvatarGroup = (0, styles_1.styled)(material_1.AvatarGroup, { shouldForwardProp: (0, general_1.omitProps)('size') })(function (_a) {
    var theme = _a.theme, _b = _a.size, size = _b === void 0 ? 'md' : _b;
    return ({
        '.MuiAvatar-root, img': __assign({ '&:not(:last-child)': {
                marginLeft: theme.spacing(-1.5),
            } }, (size && {
            width: constants_1.IMG_SIZES[size].size,
            height: constants_1.IMG_SIZES[size].size,
            fontSize: constants_1.IMG_SIZES[size].fontSize,
        })),
        '.MuiAvatar-colorDefault:first-of-type': __assign({ zIndex: 2, marginLeft: theme.spacing(-0.75), marginTop: theme.spacing(-0.25), fontWeight: theme.typography.fontWeightMedium, color: theme.palette.grey[600], backgroundColor: theme.palette.common.white, boxShadow: '0 1px 2px 0.5px rgb(255 159 191 / 80%)', whiteSpace: 'nowrap' }, (size && {
            fontSize: size === 'lg' || size === 'xl' ? 20 : constants_1.IMG_SIZES[size].fontSize - 4,
        })),
    });
});
exports.default = (0, DefaultPropsHoC_1.default)(AvatarGroup, { max: 5 });
